import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/models';
import { CommonService, ModalService, StateService } from 'src/app/services';
import jsonData from '../../data/booths.json';
declare const acquireIO: any;

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {
    public data: Global = jsonData.global;
    public hideChat: boolean = true;
    public chatEl: HTMLElement;

    public currentStateName: string;
    public mobileWarningOpen: boolean = false;
    public acquireReady: boolean = false;
    public modalOpen: boolean = false;
    public footerExpanded: boolean = false;
    public headerOpen: boolean = false;

    constructor(
        private stateSvc: StateService,
        private commonSvc: CommonService,
        private modalSvc: ModalService
    ) { }

    ngOnInit(): void {
        this.subscribe();
    }

    public subscribe(): void {
        this.commonSvc.mobileWarningOpen.subscribe(data => {
            this.chatEl = document.querySelector('.tagove-livechat-widget');
            this.mobileWarningOpen = data;
            this.toggleChatButton(!this.mobileWarningOpen, true);
        });
        this.commonSvc.acquireReady.subscribe(data => {
            this.chatEl = document.querySelector('.tagove-livechat-widget');
            this.acquireReady = data;
            if (this.acquireReady) {
                this.checkAcquireState();
            }
        });

        this.commonSvc.footerExpanded.subscribe(data => {
            this.chatEl = document.querySelector('.tagove-livechat-widget');
            this.footerExpanded = data;
            this.toggleChatButton(!this.footerExpanded, true);
        });

        this.modalSvc.modalData.subscribe(data => {
            this.chatEl = document.querySelector('.tagove-livechat-widget');
            this.modalOpen = data !== undefined;
            this.toggleChatButton(!this.modalOpen, true);
        });

        this.stateSvc.headerOpen.subscribe(data => {
            this.chatEl = document.querySelector('.tagove-livechat-widget');
            this.headerOpen = data;
            this.toggleChatButton(!this.headerOpen, true);
        });

        this.stateSvc.currentState.subscribe(data => {
            this.chatEl = document.querySelector('.tagove-livechat-widget');
            this.currentStateName = this.stateSvc.states[data];
            this.toggleChatButton(this.currentStateName.includes('BOOTH'));
        });
    }

    public toggleChatButton(show: boolean = false, force: boolean = false): void {
        if (show) {
            // this.hideChat = false;
            if (
                this.chatEl &&
                this.currentStateName.includes('BOOTH') &&
                !this.mobileWarningOpen &&
                !this.footerExpanded &&
                !this.modalOpen &&
                !this.headerOpen
            ) {
                this.chatEl.style.display = 'block';
            }
        } else {
            // this.hideChat = true;
            if (this.chatEl) {
                if (force) {
                    this.chatEl.style.display = 'none';
                } else {
                    if (acquireIO) {
                        if (acquireIO.ui.status().toLowerCase() !== 'max') {
                            this.chatEl.style.display = 'none';
                        }
                    } else {
                        this.chatEl.style.display = 'none';
                    }
                }
            }
        }
    }
    public checkAcquireState(): void {

        this.chatEl = document.querySelector('.tagove-livechat-widget');
        if (
            this.chatEl &&
            this.currentStateName.includes('BOOTH') &&
            !this.mobileWarningOpen &&
            !this.footerExpanded &&
            !this.modalOpen &&
            !this.headerOpen
        ) {
            this.chatEl.style.display = 'block';
        }

        else {
            if (acquireIO !== undefined) {
                if (acquireIO.ui.status().toLowerCase() !== 'max') {
                    this.chatEl.style.display = 'none';
                }
            } else {
                this.chatEl.style.display = 'none';
            }
        }


    }

    public openChat(): void {
        acquireIO.ui.status('max');
    }
}
